/**
 * URL parsing for /tree routes (shared by client routing and OG middleware).
 */
/**
 * Parse pathname for /tree routes. /tree/:treeId/edit takes precedence over
 * /tree/:treeId/:nodeSegment so "edit" is never treated as a node id.
 */
export function parseTreePath(pathname) {
    const editMatch = pathname.match(/^\/tree\/([^/]+)\/edit\/?$/);
    if (editMatch?.[1]) {
        return { treeId: editMatch[1], nodeSegment: null, isEditRoute: true };
    }
    const withNodeMatch = pathname.match(/^\/tree\/([^/]+)\/([^/]+)\/?$/);
    if (withNodeMatch?.[1] && withNodeMatch[2]) {
        try {
            const decoded = decodeURIComponent(withNodeMatch[2]);
            return { treeId: withNodeMatch[1], nodeSegment: decoded, isEditRoute: false };
        }
        catch {
            return { treeId: withNodeMatch[1], nodeSegment: null, isEditRoute: false };
        }
    }
    const treeOnly = pathname.match(/^\/tree\/([^/]+)\/?$/);
    if (treeOnly?.[1]) {
        return { treeId: treeOnly[1], nodeSegment: null, isEditRoute: false };
    }
    return { treeId: null, nodeSegment: null, isEditRoute: false };
}
